// Total words the app lists across public/vocab-data/n1-n5.json: every entry in the
// files (7,767 after NIH-290 and NIH-293, N5 753, N4 678, N3 1,620, N2 1,727, N1 2,989)
// minus any N5/N4 entry hidden by hiddenVocabulary.ts (NIH-282; none today). Kept as a
// constant so the homepage progress bar doesn't have to download every level's word
// list just to count them - vocabularyTotal.test.ts fails if the data files or the
// hidden list drift.
export const VOCABULARY_TOTAL = 7767;
